import './BFBackground.css';

/** Full-page animated futuristic background — grid + floating glowing orbs.
 * Renders position:absolute inset:0, so the parent must be position:relative. */
export function BFBackground() {
    return (
        <div className="bf-bg" aria-hidden="true">
            <div className="bf-bg__grid" />
            <div className="bf-bg__orb bf-bg__orb--1" />
            <div className="bf-bg__orb bf-bg__orb--2" />
            <div className="bf-bg__orb bf-bg__orb--3" />
        </div>
    );
}

export default BFBackground;
